(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('EnsambleIbqDialogController', EnsambleIbqDialogController);

    EnsambleIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Ensamble', 'MusicalPiece', 'MusicSheet'];

    function EnsambleIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Ensamble, MusicalPiece, MusicSheet) {
        var vm = this;

        vm.ensamble = entity;
        vm.clear = clear;
        vm.save = save;
        vm.musicalpieces = MusicalPiece.query();
        vm.musicsheets = MusicSheet.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ensamble.id !== null) {
                Ensamble.update(vm.ensamble, onSaveSuccess, onSaveError);
            } else {
                Ensamble.save(vm.ensamble, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:ensambleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
